import React from "react";
import useQuestionCategories from "../hooks/useQuestionCategories";
import { useNavigate } from "react-router-dom";
import CategoryModal from "../components/CategoryModal";
import "./AdminQuestionCategoryList.css";
import { useParams } from "react-router-dom";

export default function AdminQuestionCategoryList() {

    const navigate = useNavigate();
    const { domainId } = useParams();

    const {
        loading,
        sortedCategories,
        modalOpen,
        setModalOpen,
        editData,
        openCreateModal,
        openEditModal,
        deleteCategory,
        handleSave,
    } = useQuestionCategories(domainId);

    if (loading) return <h2 className="loading">Loading...</h2>;

    return (
        <div className="admin-page">

            {/* Header */}
            <div className="header">
                <h1>Question Categories</h1>

                <button className="btn primary" onClick={openCreateModal}>
                    + Add Category
                </button>
            </div>

            {/* Category List */}
            <div className="category-grid">
                {sortedCategories.map((cat) => (
                    <div className="category-card"
                        key={cat.id}
                        onClick={() => navigate(`/admin/domain/${domainId}/category-questions/${cat.id}`)}
                    >

                        <div className="info">
                            <h3>{cat.name}</h3>
                            <p className="desc">{cat.description}</p>
                            <span className="order">Order: {cat.orderId}</span>
                        </div>

                        <div className="actions">
                            <button
                                className="btn edit"
                                
                                onClick={(e) => {
                                    e.stopPropagation();       // ⛔ prevents card click
                                    openEditModal(cat.id, cat);
                                }}
                            >
                                Edit
                            </button>

                            <button
                                className="btn delete"
                                onClick={(e) => {
                                    e.stopPropagation();       // ⛔ prevents card click
                                    deleteCategory(cat.id);
                                }}
                            >
                                Delete
                            </button>
                        </div>

                    </div>
                ))}
            </div>

            {modalOpen && (
                <CategoryModal
                    editData={editData}
                    onClose={() => setModalOpen(false)}
                    onSave={handleSave}
                />
            )}
        </div>
    );
}
